<template>
  <div class="seamlescroll">
    <div class="seamlescroll-yy-top" v-if="type == 1"></div>
    <div class="seamlescroll-cont aaa" ref="box" v-if="type == 1">
      <div class="seamlescroll-item" v-for="(item, index) in logolist" :key="index">
        <vue-seamless-scroll
          v-if="item.list.length >= 1"
          :data="item.list"
          class="seamless-warp1"
          :class-option="index % 2 == 0 ? defaultOption1 : defaultOption2"
        >
          <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
            <img :src="list.url" alt="" />
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div v-if="type == 9" class="successSeaml">
      <div class="company animate__animated">
        <vue-seamless-scroll :data="lists1" :class-option="defaultOption9">
          <div class="companymain">
            <div class="companyitem" v-for="(log, j) in lists1">
              <img class="logoimg" :src="log.url" alt="" />
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <div class="company animate__animated">
        <vue-seamless-scroll :data="lists3" :class-option="defaultOption8">
          <div class="companymain">
            <div class="companyitem" v-for="(log, j) in lists3">
              <img class="logoimg" :src="log.url" alt="" />
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <div class="company animate__animated">
        <vue-seamless-scroll :data="lists2" :class-option="defaultOption9">
          <div class="companymain">
            <div class="companyitem" v-for="(log, j) in lists2">
              <img class="logoimg" :src="log.url" alt="" />
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <!-- <div class="company animate__animated">
				<vue-seamless-scroll :data="lists4" :class-option="defaultOption8">
					<div class="companymain">
						<div class="companyitem" v-for="(log, j) in lists4">
							<img class="logoimg" :src="log.url" alt="">
						</div>
					</div>
				</vue-seamless-scroll>
			</div> -->
    </div>
    <div class="seamlescroll-cont seamlescroll-cont2" ref="box" v-if="type == 2">
      <div class="seamlescroll-item seamlescroll-item2" v-for="(item, index) in logolist" :key="index">
        <vue-seamless-scroll
          v-if="item.list.length >= 1"
          :data="item.list"
          class="seamless-warp"
          :class-option="index % 2 == 0 ? defaultOption3 : defaultOption4"
        >
          <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
            <img :src="list.url" alt="" />
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="seamlescroll-cont seamlescroll-cont2" ref="box" v-if="type == 3">
      <div
        class="seamlescroll-item seamlescroll-item2"
        :class="index % 2 == 0 ? '' : 'mlft30'"
        v-for="(item, index) in logolist"
        :key="index"
      >
        <!-- <vue-seamless-scroll v-if="item.list.length>=1" :data="item.list" class="seamless-warp" :class-option="index%2==0?defaultOption3:defaultOption4"> -->
        <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
          <img :src="list.url" alt="" />
        </div>
        <!-- </vue-seamless-scroll> -->
      </div>
    </div>
    <div class="seamlescroll-cont seamlescroll-cont4" ref="box" v-if="type == 4">
      <div class="seamlescroll-item4" v-for="(item, index) in logolist4a" :key="index">
        <div class="seamlescroll-item-list"></div>
        <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
          <img :src="list.url" alt="" />
        </div>
        <div class="seamlescroll-item-list"></div>
      </div>
      <div class="seamlescroll-item4" v-for="(item, index) in logolist4b" :key="index">
        <div class="seamlescroll-item-list"></div>
        <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
          <img :src="list.url" alt="" />
        </div>
        <div class="seamlescroll-item-list"></div>
      </div>
      <div class="seamlescroll-item4" v-for="(item, index) in logolist4c" :key="index">
        <div class="seamlescroll-item-list"></div>
        <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
          <img :src="list.url" alt="" />
        </div>
        <div class="seamlescroll-item-list"></div>
      </div>
      <div class="seamlescroll-item4" v-for="(item, index) in logolist4d" :key="index">
        <div class="seamlescroll-item-list"></div>
        <div class="seamlescroll-item-list" v-for="(list, j) in item.list">
          <img :src="list.url" alt="" />
        </div>
        <div class="seamlescroll-item-list"></div>
      </div>
    </div>
    <div class="seamlescroll-yy-bottom" v-if="type == 1"></div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll"
export default {
  components: { vueSeamlessScroll },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      speed: 1,
      height: 0,
      isScroll: true,
      logolist4b: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zggl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-aolinteyao.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-duty.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-zg19.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-4.png"),
            },
          ],
        },
      ],
      logolist4c: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-zl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-wcyl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-shby.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-2.png"),
            },
          ],
        },
      ],
      logolist4d: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-4-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-4.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-5.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-5.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-2.png"),
            },
          ],
        },
      ],
      logolist4a: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-3-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-4.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-5.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hrzy.png"),
            },
          ],
        },
      ],
      logolist: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-zl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-wcyl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-shby.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zggl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-aolinteyao.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-duty.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hrzy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-zg19.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-3-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-4.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-5.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-4-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-4.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-5.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-5-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-4.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-5-5.png"),
            },
          ],
        },
      ],
      logolistess: [
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-zl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hy.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-wcyl.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-zggl.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-aolinteyao.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-duty.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-hrzy.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-3-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-3-4.png"),
            },
          ],
        },
        {
          list: [
            {
              url: require("@/assets/images/home/lblogo/logo-4-1.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-2.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-3.png"),
            },
            {
              url: require("@/assets/images/home/lblogo/logo-4-4.png"),
            },
          ],
        },
      ],
      lists1: [
        {
          url: require("@/assets/images/home/lblogo/logo-zy.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-zl.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-hy.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-wcyl.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-zggl.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-aolinteyao.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-duty.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-hrzy.png"),
        },
        
      ],
      lists2: [
        {
          url: require("@/assets/images/home/lblogo/logo-zg19.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-3-1.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-3-2.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-3-3.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-3-4.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-3-5.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-4-1.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-4-2.png"),
        },
      ],
      lists3: [
        {
          url: require("@/assets/images/home/lblogo/logo-4-3.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-4-4.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-4-5.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-5-1.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-5-2.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-5-3.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-5-4.png"),
        },
        {
          url: require("@/assets/images/home/lblogo/logo-5-5.png"),
        },


        
      ],
    }
  },
  computed: {
    defaultOption1() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 0, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    defaultOption2() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    defaultOption3() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    defaultOption4() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 3, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    defaultOption9() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    defaultOption8() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 3, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss">
.successSeaml {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .company {
    display: flex;
    //position: absolute;
    z-index: 5;
    width: 1200px;
    overflow: hidden;
    border-radius: 4px;

    .companymain {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .companyitem {
      width: 150px;
      height: 120px;
      margin-right: 20px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      flex-shrink: 0;
      cursor: pointer;
      border-width: 1px;
      border-color: rgb(232, 240, 246);
      border-style: solid;
      border-radius: 16px;
      box-shadow: 0px 10px 30px 0px rgba(51, 112, 255, 0.1);
      margin: 5px;
      .logoimg {
        max-height: 120px;
      }
    }
  }
}
</style>
<style lang="scss">
.seamlescroll {
  overflow: hidden;
  .seamlescroll-cont4 {
    width: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
  }
  .seamlescroll-cont2 {
    max-width: 700px;
    width: 100%;
    display: block !important;
  }
  .seamlescroll-cont {
    display: flex;
    align-items: flex-start;
    overflow: hidden;
  }
  .seamless-warp {
    div {
      div {
        display: flex;
      }
    }
  }
  .seamlescroll-item2 {
    display: flex;
  }
  .seamlescroll-item4 {
    display: flex;
    .seamlescroll-item-list {
      border-width: 1px;
      border-color: rgb(232, 240, 246);
      border-style: solid;
      border-radius: 16px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 10px 30px 0px rgba(51, 112, 255, 0.1);
      width: 159px;
      height: 99px;
      margin: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .seamlescroll-item {
    display: flex;
    .seamlescroll-item-list {
      border-width: 1px;
      border-color: rgb(232, 240, 246);
      border-style: solid;
      border-radius: 16px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 10px 30px 0px rgba(51, 112, 255, 0.1);
      width: 134px;
      height: 134px;
      margin: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .seamlescroll-yy-top {
    width: 100%;
    height: 231px;
    background-image: url("../../../assets/images/home/lblogotop.png");
    background-size: 100% 100%;
    position: absolute;
    top: 0;
  }
  .seamlescroll-yy-bottom {
    width: 100%;
    height: 231px;
    background-image: url("../../../assets/images/home/lblogobottom.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
</style>
